import { createClient } from '@supabase/supabase-js';

// Get Supabase URL and anon key from environment variables
// Provide fallback values in case environment variables are not available
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://lmgvogtiawzcquewtwdf.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxtZ3ZvZ3RpYXd6Y3F1ZXd0d2RmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIxNzU2ODQsImV4cCI6MjA1Nzc1MTY4NH0.SUtcXyqoegHvMBalYzAZ5oNH2Daa4KpMerCMWvgKe14';

// Validate Supabase credentials
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase credentials. Please check your .env file.');
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Types for our database tables
export type Person = {
  id?: string;
  name: string;
  day: string;
  location: 'puerto-la-cruz' | 'margarita';
  created_at?: string;
};

// Helper functions for working with Supabase
export const fetchPeople = async (location: 'puerto-la-cruz' | 'margarita') => {
  try {
    const { data, error } = await supabase
      .from('people')
      .select('*')
      .eq('location', location);
    
    if (error) {
      console.error('Error fetching people:', error);
      return null;
    }
    
    return data as Person[];
  } catch (error) {
    console.error('Error in fetchPeople:', error);
    return null;
  }
};

export const addPerson = async (person: Omit<Person, 'id' | 'created_at'>) => {
  try {
    const { data, error } = await supabase
      .from('people')
      .insert([person])
      .select();
    
    if (error) {
      console.error('Error adding person:', error);
      return null;
    }
    
    return data[0] as Person;
  } catch (error) {
    console.error('Error in addPerson:', error);
    return null;
  }
}; 